import clsx from 'clsx';
import SelectField from 'components/select-field';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';

type Props = {
  value: boolean | null,
  onChange: (value: boolean) => void,
  isDisabled: boolean,
  fullWidth?: boolean
}

export const SelectYesNo: FC<Props> = ({
  value,
  onChange,
  isDisabled,
  fullWidth = false
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  // These are already translated system values, no need for translateSelectOptions
  const options = [
    {
      title: t('common:yes'),
      value: true
    },
    {
      title: t('common:no'),
      value: false
    }
  ];

  return (
    <SelectField
      disabled={isDisabled}
      value={value !== null ? value?.toString() : ''}
      data={options}
      dataKey="value"
      dataValue="value"
      dataText="title"
      InputProps={{ className: clsx(classes.underline, { [classes.fullWidth]: fullWidth }) }}
      style={fullWidth ? undefined : { width: '77px', flex: 'none' }}
      className={classes.select}
      handleChange={(e) => {
        const isEnabled = e.target.value?.toString() === 'true';
        onChange(isEnabled);
      }}
    />
  );
};
